import { signal } from '@preact/signals';
import { emptyMeta, type Meta, type ProgressStore } from '../../net/progress';
import type { RunSummary } from '../../core/run';
import type { LeaderboardApi } from '../../net/leaderboard';

/** Vues du hub. */
export type HubView = 'home' | 'classes' | 'talents' | 'succes' | 'debloquables' | 'classements';

/** État partagé du hub (séparé de hub.tsx pour que flow.ts le lise sans dépendance circulaire). `store` est posé par app.ts. */
export const hubState = {
  meta: signal<Meta>(emptyMeta()), lastRun: signal<RunSummary | null>(null), visible: signal(false), booted: signal(false), view: signal<HubView>('home'),
  newAchievements: signal<string[]>([]), store: signal<ProgressStore | null>(null),
  /** Classements (null hors ligne), posé par app.ts quand le client Supabase existe ; pseudo du joueur (« Songeur » tant que non chargé). */
  leaderboard: signal<LeaderboardApi | null>(null), pseudo: signal<string>('Songeur'),
  /** Vue ouverte depuis l'accueil le plus récemment : à la fermeture, le focus revient sur son bouton. */
  opener: signal<HubView | null>(null),
};
